package org.moxultimate.topwithmox.techcrud.main

import org.moxultimate.topwithmox.tech.data.TechResponse

/**
 * TechCRUDState
 * Operation state for create, update, and delete actions in the tech CRUD flow.
 */
sealed class TechCRUDState {
    /** No pending operation — initial and reset state. */
    data object Idle    : TechCRUDState()

    /** Operation in progress. */
    data object Loading : TechCRUDState()

    /**
     * Operation completed successfully.
     *
     * @param message Human-readable success message to display.
     */
    data class Success(val message: String) : TechCRUDState()

    /**
     * Operation failed.
     *
     * @param message    Human-readable error description.
     * @param statusCode HTTP status code (0 when no response was received).
     */
    data class Error(val message: String, val statusCode: Int = 0) : TechCRUDState()
}

/**
 * TechListState
 * Paginated list state for the tech CRUD management page.
 */
sealed class TechListState {
    /** Initial loading state before the first page arrives. */
    data object Loading : TechListState()

    /**
     * Success state with the accumulated tech entries.
     *
     * @param techs   Accumulated (and optionally filtered) list of tech entries.
     * @param hasMore False when all pages have been loaded from the server.
     */
    data class Success(val techs: List<TechResponse>, val hasMore: Boolean = true) : TechListState()

    /**
     * Error state when the list fetch fails.
     *
     * @param message    Human-readable error description.
     * @param statusCode HTTP status code (0 when no response was received).
     */
    data class Error(val message: String, val statusCode: Int = 0) : TechListState()
}
